import { ISelectOption } from '@smartshell/ui-kit';

import { EOpf } from 'settings';
import { Tax } from 'types';

import { ICreateBeneficiaryForm } from './interfaces';

const DEFAULT_VALUE: ICreateBeneficiaryForm = {
  ul: {
    opf: null,
    name: '',
    inn: '',
    registration_date: '',
    legal_entity_address: '',
    ogrn: '',
  },
  ip: {
    last_name: '',
    first_name: '',
    middle_name: '',
    citizenship: null,
    registration_date: '',
    birth_date: '',
    registration_address: '',
    inn: '',
  },
  passport: {
    serial: '',
    number: '',
    date: '',
    division_code: '',
  },
  phone: '',
  email: '',
  bank_name: '',
  bank_bik: '',
  bank_kpp: '',
  bank_account: '',
  correspondent_account: '',
  check_policy: false,
  service_name: null,
  tax: null,
};

const OPF_OPTION: ISelectOption<EOpf>[] = [
  {
    title: EOpf.OOO,
    value: EOpf.OOO,
  },
  {
    title: EOpf.OAO,
    value: EOpf.OAO,
  },
  {
    title: EOpf.AO,
    value: EOpf.AO,
  },
];

const taxOption: ISelectOption[] = [
  {
    value: Tax.NONE,
    title: 'Без НДС',
  },
  {
    value: Tax.VAT0,
    title: 'НДС 0%',
  },
  {
    value: Tax.VAT10,
    title: 'НДС 10%',
  },
  {
    value: Tax.VAT20,
    title: 'НДС 22%',
  },
  {
    value: Tax.VAT110,
    title: 'НДС 110%',
  },
  {
    value: Tax.VAT120,
    title: 'НДС 120%',
  },
];

export { OPF_OPTION, DEFAULT_VALUE, taxOption };
